import subscribeToCoreUpdates from "../core_updates_channel";
import { store } from "../../store";
import { addLog } from "../../ReduxSlices/Prescriptions/dispensationLogSlice";

let unsubscribeDispensation = null; // store unsubscribe function

export const initializeDispensationSubscription = () => {
  if (unsubscribeDispensation) return; // already subscribed

  // Provide a unique module key "dispensation"
  unsubscribeDispensation = subscribeToCoreUpdates("dispensation", {
    "dispensation_log.dispensed": (data) => {
      store.dispatch(addLog(data.log));
    },
  });

  //console.log("✅ Dispensation subscription initialized");
};

export const unsubscribeDispensationSubscription = () => {
  if (unsubscribeDispensation) {
    unsubscribeDispensation(); // remove only this module's handlers
    unsubscribeDispensation = null;
    //console.log("🔌 Dispensation subscription removed");
  }
};